import gql from 'graphql-tag';

export default gql`
  query cities($countryId: Int, $stateId: Int!) {
    cities(countryId: $countryId, stateId: $stateId) {
      id
      name
      code
    }
  }
`;
